import { loader } from 'graphql.macro';
import { useAppDispatch, useAppSelector, toArraySafe, RiskEvaluationQuestionsQueryVariables, RiskEvaluationQuestions, RiskEvaluationQuestionsQuery, setRiskEvaluationQuestions } from 'Store';
import { useApiQuery } from '../useApiQuery';
import { ApiQueryKey } from '../../types';
import { useState } from 'react';
import { UseApiQueryReturn } from '../types';
import { API_QUERIES } from '../../constants';

const GET_RISK_EVALUATION_QUESTIONS = loader('src/GQL/RiskEvaluation/GetRiskEvaluationQuestions.gql');

export const useRiskEvaluationQuestionsQuery = (): UseApiQueryReturn => {
	const apiQueryKey = ApiQueryKey.RiskEvaluationQuestions;

	const dispatch = useAppDispatch();

	const { metadata } = useAppSelector(state => state.apiData.riskEvaluationQuestions);

	// Set to false as we're offline first, this prevents immediate querying
	const [canFetchQuery, setCanFetchQuery] = useState<boolean>(false);

	useApiQuery<RiskEvaluationQuestionsQuery, RiskEvaluationQuestions, RiskEvaluationQuestionsQueryVariables>({
		apiQueryKey,
		canFetchQuery: canFetchQuery,
		documentNode: GET_RISK_EVALUATION_QUESTIONS,
		dataSelector: query => toArraySafe(query?.riskEvaluationQuestions),
		setCanFetchQuery,
		setData: partial => {
			dispatch(setRiskEvaluationQuestions({ ...partial }));
		},
		options: {
			fetchPolicy: 'no-cache',
			nextFetchPolicy: 'no-cache',
		},
	});

	return {
		apiQueryKey,
		apiQuery: API_QUERIES[apiQueryKey],
		metadata,
		setCanFetchQuery,
	};
};

